<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-button type="primary" size="small" @click="getList()">
          查询
        </el-button>
      </el-row>
      <el-table :data="listData" style="width: 100%" border v-loading="listLoading">
        <el-table-column prop="id" label="活动ID" width="90"></el-table-column>

      </el-table>

    </el-row>
  </div>
</template>

<script>
import {
  orderList
} from "@/api/activityCamp";

export default {
  data:function () {
    return {
      listData:[],
      listLoading:false,
    }
  },
  created: function() {
    this.getList();
  },
  methods: {
    getList(){
      this.listLoading = true;
      orderList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
      });
    },
  },
}
</script>
<style>
.el-button{
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>